import { TypographyProps } from '@mui/material';
import { styled, Text } from '@/theme/index';

export const StyledText = ({ children, ...rest }: TypographyProps) => (
  <Text variant="body1" lineHeight={1} {...rest}>
    {children}
  </Text>
);

export const StyledImage = styled('img')(() => ({
  width: '50px',
  height: '50px',
  borderRadius: '10px',
  objectFit: 'cover',
  flexShrink: 0,
}));
